export default __webpack_public_path__ + "static/media/CivilEng_IMG-PipeJacking-02.2de55047.png";